export * from './SelectIcon';

import {ClearIndicator} from './ClearIndicator';
import {DropdownIndicator} from './DropdownIndicator';
import {MultiValueContainer} from './MultiValueContainer';
import {MultiValue} from './MultiValue';
import {SelectIcon} from './SelectIcon';

export {NoOptionsMessage} from './NoOptionsMessage';

export const selectComponents = {
  ClearIndicator,
  DropdownIndicator,
  MultiValue,
  MultiValueContainer,
  SelectIcon,
};
